export const getCurrentLocaleByObjectTitle = (objectData, locale) => {
  if (objectData?.restrictions && locale === 'en') {
    return objectData?.restrictions?.value || ''
  }

  return objectData?.title?.value || ''
}
